module.exports = "/static/assets/7ce6b51fdb86dcf8b994bb5ddd9c666b.png";